export type BankAccount = {
	id: number;
	companyId?: number;
	iban?: string;
	status?: string;
	accountOwnerName: string;
	reference: string;
	bankOrigin?: string;
	bankBranch: string;
	accountNumber: string;
	bankName: any;
	currencyId: number;
	bank?: any;
	currency?: any;
	accountBankId?: any;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date;
};

// --- Bank Account
export enum BankAccountStatus {
	None = 'None',
	Pending = 'Pending',
	PendingSigning = 'PendingSigning',
	Completed = 'Completed',
	Rejected = 'Rejected',
	Failed = 'Failed',
	Deleted = 'Deleted',
}
